import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    mainContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
    },
    scrollbar: {
        overflowY: 'scroll',
        overflowX: 'hidden',
        minHeight: '700px',
        [theme.breakpoints.only('xs')]: {
            // minHeight: 'unset',
            height: '95% !important',
        },
    },

    delivery: {
        textAlign: 'center',
        // borderBottom: `1px solid ${theme.palette.primary.borderColor}`,
        paddingBottom: '14px',
        fontFamily: theme.typography.body3Medium.fontFamily,
        // fontWeight: 700,
        fontSize: theme.typography.h5.fontSize,
        lineHeight: '26px',
        color: theme.palette.primary.heather,
    },
    marginBlock: {
        marginTop: '21px',
        [theme.breakpoints.down('sm')]: {
            marginTop: '10px',
        },
    },

    eircodeContainer: {
        '& .MuiInputLabel-outlined.Mui-error': {
            color: theme.palette.primary.error,
        },
        width: '464px',
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '32px',
        marginBottom: '16px',
        [theme.breakpoints.down('sm')]: {
            '& .MuiGrid-item': {
                padding: '8px',
            },
            width: '100%',
            marginTop: '28px',
        },
    },
    addresslineOne: {
        '& .MuiInputLabel-root': {
            marginTop: '5px',
        },
        '& .MuiInputLabel-root.Mui-focused': {
            marginTop: '0',
        },
    },

    addressContainer: {
        width: '440px',
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '16px',
        [theme.breakpoints.down('sm')]: {
            width: '95%',
        },
    },
    hideTextField: {
        opacity: '0',
        height: '0',
        zIndex: '-1',
        paddingTop: '0 !important',
    },

    ctaGrid: {
        [theme.breakpoints.down('sm')]: {
            order: 3,
        },
    },

    cta: {
        textTransform: 'none',
        fontStyle: 'normal',
        // fontWeight: '700',
        fontSize: '1rem',
        fontFamily: theme.typography.body3Medium.fontFamily,
        lineHeight: '1.5',
        padding: '.5rem 2rem',
        minWidth: '208px',
        margin: '0 auto ',
        background: theme.palette.primary.sunset,
        borderRadius: '4100px',
        color: theme.palette.primary.white,
        '&:hover': {
            background: theme.palette.primary.sunset30,
        },
        [theme.breakpoints.down('sm')]: {
            // width: '264px',
            width: '100%',
            height: '41px',
            // top: '214px',
            left: '.69%',
            right: '7.69%',
        },
    },

    cta1: {
        textTransform: 'none',
        fontStyle: 'normal',
        // fontWeight: '700',
        fontSize: '1rem',
        fontFamily: theme.typography.body3Medium.fontFamily,
        lineHeight: '1.5',
        padding: '.5rem 2rem',
        margin: '0 auto ',
        background: theme.palette.primary.sunset30,
        width: '100%',
        maxWidth: '200px',
        borderRadius: '4100px',
        color: theme.palette.primary.white,
        '&:hover': {
            background: theme.palette.primary.sunset30,
        },
        [theme.breakpoints.down('md', 'sm')]: {
            maxWidth: '200px',
            width: '100%',
        },
        [theme.breakpoints.only('xs')]: {
            maxWidth: '296px',
            width: '100%',
            height: '41px',
            left: '.69%',
            right: '7.69%',
        },
    },

    ctaDisable1: {
        '&.Mui-disabled': {
            color: theme.palette.primary.gray550,
            borderRadius: '4100px',
            background: `${theme.palette.primary.borderColor} !important`,
            textTransform: 'none',
            fontStyle: 'normal',
            fontWeight: '700',
            fontSize: '1rem',
            fontFamily: theme.typography.body1.fontFamily,
            lineHeight: '1.5',
            padding: '.5rem 2rem',
            maxWidth: '200px',
            width: '100%',
            margin: '0 auto ',
            marginTop: '10px',
            [theme.breakpoints.down('md', 'sm')]: {
                maxWidth: '200px',
                width: '100%',
            },
            [theme.breakpoints.only('xs')]: {
                maxWidth: '296px',
                width: '100%',
                height: '41px',
                left: '.69%',
                right: '7.69%',
            },
        },
    },

    textContainer: {
        lineHeight: '157%',
        fontFamily: theme.typography.body2.fontFamily,
        fontWeight: '600',
        fontSize: theme.typography.subtitle2.fontSize,
        textAlign: 'center',
        margin: '0 auto ',
        color: theme.palette.primary.heather,
        paddingTop: '28px',
        [theme.breakpoints.down('xs')]: {
            maxWidth: '296px',
            paddingTop: '1rem',
        },
    },

    activateSim: {
        fontSize: '.875rem',
        fontFamily: theme.typography.body3Medium.fontFamily,
        fontWeight: 400,
        fontStyle: 'normal',
        color: theme.palette.primary.sunset,
        '@media (max-width:300px)': {
            fontSize: '11px',
        },
    },
    textContext: {
        color: theme.palette.primary.sunset,
        fontFamily: theme.typography.body3Medium.fontFamily,
        fontWeight: '500',
        fontSize: theme.typography.body1.fontSize,
        textAlign: 'center',
    },

    simLink: {
        fontSize: theme.typography.subtitle2.fontSize,
        lineHeight: '157%',
        fontFamily: theme.typography.body3Medium.fontFamily,
        fontWeight: '400',
        color: theme.palette.primary.sunset,
    },

    textFieldotp: {
        margin: '2.5rem 0px 1.5rem 0px',
        padding: '0px 13.36rem 0rem',
        width: '100%',
        [theme.breakpoints.down('xs')]: {
            margin: '2rem 0 1rem',
            padding: '0px 0.47rem 0rem',
            maxWidth: '296px',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
    },

    ctaDisable: {
        '&.Mui-disabled': {
            // boxShadow:
            //     '0 1px 5px 0 ${theme.palette.primary.boxShadow2Dark}), 0 2px 2px 0 ${theme.palette.primary.boxShadow2Dark}), 0 3px 1px 0 ${theme.palette.primary.boxShadow2Dark})',
            color: theme.palette.primary.gray550,
            borderRadius: '4100px',
            background: `${theme.palette.primary.borderColor} !important`,
            textTransform: 'none',
            fontStyle: 'normal',
            fontWeight: '700',
            fontSize: '1rem',
            fontFamily: theme.typography.body1.fontFamily,
            lineHeight: '1.5',
            padding: '.5rem 2rem',
            minWidth: '208px',
            margin: '0 auto ',
            [theme.breakpoints.down('sm')]: {
                // width: '264px',
                width: '100%',
                height: '41px',
                // top: '214px',
                left: '.69%',
                right: '7.69%',
            },
        },
    },

    textField: {
        width: '100%',
        height: '56px',
        margin: '0',
        '& .MuiInputBase-root': { height: '56px' },
        // colors on focus
        '& .MuiInputLabel-root': { color: theme.palette.primary.heather80 },
        '& .Mui-focused': {
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: theme.palette.primary.heather80,
                borderWidth: 2,
            },
            '&.MuiInputLabel-root': {
                color: theme.palette.primary.heather80,
            },
        },
        '& .Mui-error': {
            color: theme.palette.primary.error,
        },

        // helper text
        '& .MuiFormHelperText-contained': {
            fontFamily: theme.typography.body2.fontFamily,
            color: theme.palette.primary.heather,
            margin: 0,
            fontSize: 14,
            lineHeight: '20px',
        },

        '& .MuiInputLabel-outlined.Mui-error': {
            color: theme.palette.primary.error,
        },
    },

    simImg: {
        position: 'relative',
        marginTop: '29px',
        marginBottom: '3.5px',
        [theme.breakpoints.down('sm')]: {
            marginTop: '14.5px',
        },
    },

    textBold: {
        fontFamily: theme.typography.body3Medium.fontFamily,
        // fontWeight: '700',
        fontSize: theme.typography.h5.fontSize,
        lineHeight: '26px',
        color: theme.palette.primary.heather,
    },

    text: {
        fontSize: theme.typography.subtitle2.fontSize,
        lineHeight: '157%',
        fontFamily: theme.typography.body3Medium.fontFamily,
        fontWeight: '600',
        color: theme.palette.primary.heather,
        marginTop: '3.5px',
    },

    link: {
        fontSize: theme.typography.inputLabel.fontSize,
        cursor: 'pointer',
        lineHeight: '20px',
        fontFamily: theme.typography.body2.fontFamily,
        fontWeight: '400',
        color: theme.palette.primary.sunset,
        marginTop: '-7px',
        letterSpacing: '0.4px',
        textDecoration: 'underline',
        width: '437px',
        margin: '0 auto',

        [theme.breakpoints.down('sm')]: {
            width: '95%',
            marginBottom: '12px',
            order: 2,
        },
        [theme.breakpoints.only('sm')]: {
            width: '95%',
            marginBottom: '14px',
            order: 2,
            textAlign: 'center',
        },
    },

    cost: {
        fontFamily: theme.typography.subtitle3.fontFamily,
        // fontWeight: '700',
        fontSize: theme.typography.subtitle3.fontSize,
        lineHeight: theme.typography.subtitle3.lineHeight,
        color: theme.palette.primary.heather,
        marginTop: '23px',
        marginBottom: '28px',

        [theme.breakpoints.down('sm')]: {
            fontSize: theme.typography.subtitle3.fontSize,
            marginTop: '7px',
            marginBottom: ' 18px',
        },
    },
    errorMessage: {
        width: '100%',
        fontFamily: theme.typography.body2.fontFamily,
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: theme.typography.inputLabel.fontSize,
        lineHeight: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        letterSpacing: '0.4px',
        color: theme.palette.primary.error,
        marginTop: '3px',
    },
    blockText: {
        width: '440px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto',
        textAlign: 'center',
        marginTop: '23px',
        [theme.breakpoints.down('sm')]: {
            width: '92%',
            marginTop: '12px',
        },
    },
    serviceText: {
        fontSize: theme.typography.inputLabel.fontSize,
    },

    checkBlock: {
        width: '254px',
        margin: '0 auto',
        display: 'flex',
        textAlign: 'left',
        marginTop: '21px',
        height: '16px',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '21px',
        [theme.breakpoints.down('sm')]: {
            marginTop: '14px',
            marginBottom: '14px',
        },
    },
    checkbox: {
        '& .MuiIconButton-label': {
            width: '16px',
            height: '16px',
        },
        '&.MuiCheckbox-colorSecondary.Mui-checked': {
            color: theme.palette.primary.heather,
        },
    },
    checkText: {
        textDecoration: 'none',
        fontSize: theme.typography.inputLabel.fontSize,
        // fontWeight: 700,
        color: theme.palette.primary.heather,
        fontFamily: theme.typography.subtitle1.fontFamily,
    },

    successPopup: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
    },

    successImg: {
        marginTop: '27px',
        marginBottom: '43px',
        [theme.breakpoints.down('sm')]: {
            marginBottom: '19px',
            marginTop: '67px',
        },
    },

    imgTextAdditional: {
        fontSize: theme.typography.body1.fontSize,
        lineHeight: '157%',
        fontFamily: theme.typography.body3Medium.fontFamily,
        fontWeight: '600',
        color: theme.palette.primary.heather,
        marginBottom: '48px',
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center',
            marginRight: '30px',
            marginLeft: '30px',
            marginBottom: '45px',
        },
    },
    err: {
        textAlign: 'center',
        fontFamily: theme.typography.body1.fontFamily,
        marginBottom: '20px',
    },

    linkStyle: {
        width: 'max-content',
    },

    linkStyles: {
        fontFamily: theme.typography.body3Medium.fontFamily,
        fontWeight: '400',
        fontSize: theme.typography.subtitle2.fontSize,
    },

    inactiveContainer: {
        marginTop: '26px',
        marginBottom: '60px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',

        [theme.breakpoints.down('sm')]: {
            textAlign: 'center',
            margin: '0 auto',
            marginTop: '21px',
        },
        [theme.breakpoints.between('sm', 'md')]: {
            marginBottom: '50px',
        },
    },

    inactiveText: {
        fontSize: theme.typography.subtitle2.fontSize,
        lineHeight: '157%',
        fontFamily: theme.typography.body2.fontFamily,
        fontWeight: '600',
        color: theme.palette.primary.heather,
        marginBottom: '16px',
    },
    buttonBox: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    simCta: {
        textTransform: 'none',
        fontStyle: 'normal',
        // fontWeight: '700',
        fontSize: '1rem',
        fontFamily: theme.typography.body3Medium.fontFamily,
        lineHeight: '1.5',
        padding: '.5rem 2rem',
        margin: '0 auto ',
        minWidth: '184px',
        [theme.breakpoints.down('sm')]: {
            height: '41px',
            left: '.69%',
            right: '7.69%',
            borderRadius: '4100px',
            maxWidth: '296px',
            width: '100%',
        },
    },
    simCta1: {
        boxShadow: `0 1px 5px 0 ${theme.palette.primary.boxShadow2Dark}, 0 2px 2px 0 ${theme.palette.primary.boxShadow2Dark}, 0 3px 1px 0 ${theme.palette.primary.boxShadow2Dark}`,
        color: theme.palette.primary.white,
        borderRadius: '4rem',
        background: theme.palette.primary.sunset,
        '&:hover': {
            background: theme.palette.primary.sunset30,
        },
    },
    mb: {
        marginBottom: '0px',
        [theme.breakpoints.down('sm')]: {
            marginBottom: '40px',
        },
    },
    MB: {
        marginBottom: '18px',
        [theme.breakpoints.down('sm')]: {
            marginBottom: '40px',
        },
    },
    simCta1Disable: {
        // boxShadow:
        //     '0 1px 5px 0 ${theme.palette.primary.boxShadow2Dark}), 0 2px 2px 0 ${theme.palette.primary.boxShadow2Dark}), 0 3px 1px 0 ${theme.palette.primary.boxShadow2Dark})',
        color: theme.palette.primary.gray550,
        borderRadius: '4rem',
        background: theme.palette.primary.borderColor,
        [theme.breakpoints.down('sm')]: {
            color: theme.palette.primary.gray550,
            borderRadius: '4rem',
            background: `${theme.palette.primary.borderColor} !important`,
        },
    },
    simCta2: {
        color: theme.palette.primary.sunset,
        textAlign: 'center',
        fontSize: theme.typography.body1.fontSize,
        // marginTop: '12px',
    },
    SimreplacementWrapper: {
        '& .details-Activate-SIM': {
            fontFamily: theme.typography.body3Medium.fontFamily,
            fontWeight: 400,
            fontStyle: 'normal',
            fontSize: '.875rem',
            lineHeight: '157%',
            color: theme.palette.primary.sunset,
            textDecorationLine: 'underline',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            padding: '.5rem',
            [theme.breakpoints.down('sm')]: {
                fontFamily: theme.typography.body3Medium.fontFamily,
                fontWeight: 400,
                fontStyle: 'normal',
                fontSize: '.875rem',
                color: theme.palette.primary.sunset,
            },
        },
        '& .verticalLine': {
            borderLeft: `0px solid ${theme.palette.primary.borderColor}`,
            color: theme.palette.primary.borderColor,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: '.7rem',
            paddingRight: '.7rem',
            textAlign: 'right',
        },
        '& .details-topic-order': {
            fontFamily: theme.typography.body3Medium.fontFamily,
            fontWeight: 400,
            fontStyle: 'normal',
            display: 'flex',
            fontSize: '.875rem',
            lineHeight: '157%',
            color: theme.palette.primary.sunset,
            textDecorationLine: 'underline',
            cursor: 'pointer',
            flexGrow: '0',
            textAlign: 'right',
            [theme.breakpoints.down('sm')]: {
                fontFamily: theme.typography.body3Medium.fontFamily,
                fontWeight: 400,
                fontStyle: 'normal',
                display: 'flex',
                fontSize: '.875rem',
                lineHeight: '157%',
                color: theme.palette.primary.sunset,
                position: 'absolute',
                right: '0',
            },
            '@media (min-width:600px) and (max-width:959px) ': {
                marginRight: '62px',
            },
        },
        '& .no-flex': {
            [theme.breakpoints.down('xs')]: {
                left: '0',
            },
        },
        '& .Activate-SIM': {
            fontFamily: theme.typography.body2.fontFamily,
            fontWeight: 400,
            fontStyle: 'normal',
            width: '200px',
            fontSize: theme.typography.subtitle2.fontSize,
            lineHeight: '157%',
            color: theme.palette.primary.sunset,
            textDecorationLine: 'underline',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            // padding: '.5rem',
            [theme.breakpoints.down('sm')]: {
                fontFamily: theme.typography.body3Medium.fontFamily,
                fontWeight: 400,
                fontStyle: 'normal',
                fontSize: '.875rem',
                color: theme.palette.primary.sunset,
            },
        },
        '& .tile-reorder': {
            width: '60px',
        },
        '& .details-topic-title': {
            fontFamily: theme.typography.subtitle3.fontFamily,
            fontWeight: 700,
            fontStyle: 'normal',
            fontSize: theme.typography.subtitle3.fontSize,
            lineHeight: theme.typography.subtitle3.lineHeight,
            color: theme.palette.primary.heather,
            textAlign: 'left',

            [theme.breakpoints.down('sm')]: {
                fontSize: theme.typography.subtitle3.fontSize,
                lineHeight: '1.0625rem',
            },
        },

        '& .sim': {
            fontFamily: theme.typography.subtitle1.fontFamily,
            fontStyle: 'normal',

            fontSize: theme.typography.subtitle2.fontSize,
            // fontWeight: 600,
            color: theme.palette.primary.heather,
            display: 'flex',
            width: '100%',
            [theme.breakpoints.down('xs')]: {
                display: 'flex',
                fontSize: theme.typography.subtitle2.fontSize,
                fontFamily: theme.typography.subtitle1.fontFamily,
                // fontWeight: 600,
                width: '100%',
            },
        },
        '& .phonenumber': {
            fontFamily: theme.typography.subtitle1.fontFamily,
            fontStyle: 'normal',
            marginLeft: '16px',
            fontSize: theme.typography.subtitle1.fontSize,
            fontWeight: 600,
            color: theme.palette.primary.heather,
            display: 'flex',
            alignItems: 'center',
            [theme.breakpoints.down('xs')]: {
                display: 'flex',
                alignItems: 'center',
            },
            '@media (max-width:300px)': {
                fontSize: '11px',
                marginLeft: '6px',
            },
        },
        '& .sim-img': {
            alignItems: 'flex-end',
            width: '100%',
            // display: 'flex',
            // padding: '24px 6px',
            padding: '24px 8px 5px 8px',
            [theme.breakpoints.down('xs')]: {
                // display: 'flex',
                padding: '24px 6px',
            },
        },
        '& .sim-link': {
            display: 'flex',
            [theme.breakpoints.down('xs')]: {
                display: 'block !important',
            },
        },
        '& .sim-img:last-child': {
            '& .divider-line': {
                display: 'none',
            },
        },
        '& .simTile': {
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            [theme.breakpoints.down('xs')]: {
                position: 'relative',
            },
        },
        '& .block': {
            [theme.breakpoints.down('xs')]: {
                display: 'block',
            },
        },
        '& .sim-img-container': {
            alignItems: 'flex-end',
            width: '100%',
            display: 'flex',
            padding: '24px 5px',
            paddingBottom: '20px',
            [theme.breakpoints.down('xs')]: {
                display: 'flex',
                padding: '24px 5px',
                paddingBottom: '0px',
                flexDirection: 'column',
            },
        },

        '& .divider-line': {
            color: theme.palette.primary.white,
            boxShadow: `0px 1px 0px ${theme.palette.primary.boxShadow2Dark}`,
            // width: '150%',
            height: '1px',

            background: theme.palette.primary.boxShadow2Dark,
            marginTop: '27px',
            [theme.breakpoints.down('xs')]: {
                width: '100%',
                marginTop: '24px',
            },
        },
    },

    DividerLine: {
        color: theme.palette.primary.white,
        boxShadow: `0px 1px 0px ${theme.palette.primary.boxShadow2Dark}`,
        // width: '150%',
        height: '1px',

        background: theme.palette.primary.boxShadow2Dark,
        marginTop: '1px',
        marginBottom: '43px',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            marginTop: '14.7px',
            marginBottom: '24px',
        },
    },

    AccountWrapper: {
        margin: 'auto',
        maxWidth: '995px',
        marginBottom: '60px',
        position: 'relative',

        '@media (min-width: 500px) and (max-width:599px)': {
            maxWidth: '570px',
            paddingLeft: '30px',
            paddingRight: '30px',
        },

        '@media (min-width: 600px) and (max-width:1019px)': {
            maxWidth: '694px',
            // paddingLeft: '30px',
            // paddingRight: '30px',
            marginBottom: '51px',
            width: '100%',
        },
        '@media (min-width: 0px) and (max-width:499px)': {
            maxWidth: '344px',
        },

        '@media (min-width: 1020px) and (max-width:1199px)': {
            maxWidth: '995px',
            margin: 'auto',
            marginTop: '40px',
            paddingLeft: '30px',
            marginBottom: '40px',
            paddingRight: '30px',
        },
    },

    DetailsContainer: {
        background: theme.palette.primary.white,
        boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow2Dark}, 0px 10px 14px 1px ${theme.palette.primary.boxShadow2Medium}, 0px 4px 18px 3px ${theme.palette.primary.boxShadow2Lite}`,
        borderRadius: '10px',
        margin: 'auto',
        padding: '29px 32px',
        // maxWidth: 'calc(995 / 1468 * 100vw)',
        maxWidth: '995px',

        '@media(max-width: 1019px)': {
            maxWidth: '694px',
        },

        '@media(max-width: 599px)': {
            maxWidth: 'calc(344 / 360 * 100vw)',
            padding: '19.5px 16px',
        },
        '@media(min-width: 1920px)': {
            maxWidth: '1076px',
        },
    },
    arrow: {
        height: '24px',
        width: '24px',
        color: theme.palette.primary.sunset,
        cursor: 'pointer',
        '@media(max-width: 599px)': {
            height: '21px',
            width: '21px',
            paddingLeft: '1px',
        },
    },

    headerBackIcon: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        marginLeft: '-3px',
    },

    detailsHeaderbackText: {
        display: 'flex',
        marginTop: '17px',
        minHeight: '45px',
        fontFamily: theme.typography.h1.fontFamily,
        fontStyle: 'normal',
        // fontWeight: 700,
        fontSize: theme.typography.h4.fontSize,
        lineHeight: '26px',
        color: theme.palette.primary.heather,
        position: 'relative',

        '@media(max-width: 599px)': {
            paddingLeft: '0px',
            marginTop: '7px',
            minHeight: '32px',
            fontSize: theme.typography.h4.fontSize,
            marginLeft: '0px',
            paddingBottom: '0px',
        },

        '& .changeEmail-header-line': {
            position: 'absolute',
            left: '0%',
            right: '0%',
            bottom: '3px',
            border: `1px solid ${theme.palette.primary.borderColor}`,
            borderTopWidth: '0px',

            '@media(max-width: 599px)': {
                bottom: '0px',
            },
        },
    },

    ApiError: {
        color: theme.palette.primary.heather,
        fontSize: theme.typography.subtitle2.fontSize,
        margin: '10px 0',
    },
    modalContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        padding: '0 63px',
        [theme.breakpoints.down('sm')]: {
            padding: '0 8px',
        },
    },
    headingText: {
        color: theme.palette.primary.heather,
        marginBottom: '8px',
        marginTop: '8px',
        [theme.breakpoints.down('sm')]: {
            marginBottom: '16px',
        },
    },
    descriptionText: {
        color: theme.palette.primary.heather,
    },
    inlineHeading: {
        marginRight: '4px',
    },
    infoRow: {
        display: 'flex',
        alignItems: 'flex-start',
        padding: '0 32px',
        [theme.breakpoints.down('sm')]: {
            padding: '0 8px',
        },
        gap: '5px',
    },
    icon: {
        width: '30px',
        height: '30px',
        color: theme.palette.primary.sunset,
    },
    esimReplacementContent: {
        padding: '48px 63px 0',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: '16px',
        [theme.breakpoints.down('sm')]: {
            padding: '14px 0 0',
        },
    },
    esimReplacementText: {
        color: theme.palette.primary.heather,
    },
    esimReplacementEmailField: {
        marginTop: '8px',
        '& .MuiInputBase-root': {
            height: '40px',
            borderRadius: 8,
        },
    },
    esimReplacementSectionTitle: {
        marginTop: '8px',
        color: theme.palette.primary.heather,
    },
    esimReplacementCheckboxLabel: {
        display: 'flex',
        alignItems: 'center',
        color: theme.palette.text.primary,
    },
    esimReplacementCheckbox: {
        padding: 4,
        color: theme.palette.primary.heather,
        '&.Mui-checked': {
            color: theme.palette.primary.heather,
        },
    },
    esimReplacementLink: {
        color: theme.palette.primary.sunset,
        cursor: 'pointer',
        textDecoration: 'underline',
    },
    cancelLink: {
        color: theme.palette.primary.sunset,
        cursor: 'pointer',
        textDecoration: 'underline',
        '&:hover': {
            color: theme.palette.primary.sunset,
        },
    },
    simTypeText: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: '8px',
        color: theme.palette.primary.heather80,
        textTransform: 'none',
    },
    esimActivationContent: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        padding: '30px 0 0 0',
        [theme.breakpoints.up('sm')]: {
            padding: '48px 63px 0',
        },
    },
    esimActivationInstruction: {
        color: theme.palette.primary.heather,
    },
    QrCodeContainer: {
        display: 'flex',
        justifyContent: 'center',
        [theme.breakpoints.up('sm')]: {
            justifyContent: 'flex-start',
            alignSelf: 'flex-start',
        },
        paddingTop: '24px',
        paddingBottom: '4px',
        paddingLeft: '4px',
    },
    esimActivationQrImage: {
        width: '169.31px',
        height: '169.31px',
        display: 'block',
        margin: '0 auto',
        color: theme.palette.primary.heather,
    },
    esimActivationDownloadLink: {
        display: 'flex',
        justifyContent: 'center',
        color: theme.palette.primary.sunset,
        textDecoration: 'underline',
        lineHeight: '22px',
        '&:visited': {
            color: theme.palette.primary.sunset,
        },
        '&:hover': {
            color: theme.palette.primary.sunset,
        },
        paddingBottom: '24px',
        [theme.breakpoints.up('sm')]: {
            justifyContent: 'flex-start',
            marginLeft: '24px',
            // marginLeft:'63px'
        },
    },
    passcodeBox: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: theme.palette.primary.gray250,
        borderRadius: '6px',
        padding: '0px 16px',
        marginTop: '16px',
        marginBottom: '24px',
        [theme.breakpoints.up('sm')]: {
            width: '190px',
        },
    },
    passcodeText: {
        lineHeight: '16px',
        color: theme.palette.primary.heather,
    },
    copyIcon: {
        color: theme.palette.primary.sunset,
    },
    alertBox: {
        '& .MuiSvgIcon-root': { color: theme.palette.primary.midNightBlue },
        '& .MuiAlert-message': { color: theme.palette.primary.midNightBlue },
        flexGrow: 1,
        marginBottom: '8px',
    },
    alertTitleText: {
        marginBottom: '0px',
    },
    stepList: {
        paddingLeft: '16px',
        margin: 0,
    },
    QRCodeLink: {
        paddingRight: '8px',
    },

    orderSIMContainer: {
        padding: '48px 136.5px 0 136.5px',
        [theme.breakpoints.down('xs')]: {
            padding: '30px 0 0',
        },
    },
    helperText: {
        color: theme.palette.primary.heather,
    },
    simOption: {
        // maxWidth:'423px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        cursor: 'pointer',
        padding: '16px 0px 16px 16px',
        marginright: '16px',
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        },
    },
    simInfoContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    simIconContainer: {
        marginRight: '24px',
        display: 'flex',
        alignItems: 'center',
    },
    simIcon: {
        fontSize: 32,
        color: theme.palette.primary.sunset,
    },
    simTextContainer: {
        display: 'flex',
        flexDirection: 'column',
    },
    simTitle: {
        color: theme.palette.primary.heather,
    },
    esimTitle: {
        color: theme.palette.primary.heather,
        paddingRight: '8px',
    },
    simSubtitle: {
        color: theme.palette.primary.heather,
    },
    arrowIcon: {
        // padding:'2px',
    },
    simArrow: {
        color: theme.palette.primary.sunset,
    },
    esimInfoLink: {
        fontSize: theme.typography.subtitle2.fontSize,
        lineHeight: '157%',
        fontFamily: theme.typography.body3Medium.fontFamily,
        fontWeight: '400',
        color: theme.palette.primary.sunset,
        textDecoration: 'underline',
        cursor: 'pointer',
        '&:hover': {
            color: theme.palette.primary.sunset,
        },
    },
    esimNewInfoLink: {
        fontSize: theme.typography.subtitle2.fontSize,
        lineHeight: '157%',
        fontFamily: theme.typography.body3Medium.fontFamily,
        fontWeight: '400',
        color: theme.palette.primary.sunset,
        cursor: 'pointer',
        '&:hover': {
            color: theme.palette.primary.sunset,
        },
    },
}));

export default useStyles;
